export function formatDateTime(isoString, options = {}) {
    const date = new Date(isoString);
  
    // Check if the date is valid
    if (isNaN(date.getTime())) {
      throw new Error('Invalid ISO date string');
    }
  
    // Default options
    const defaultOptions = {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone, // Get system timezone
    };
  
    // Merge user options with defaults
    const mergedOptions = { ...defaultOptions, ...options };
  
    // Use the browser's/system's locale settings with the timezone.
    return new Intl.DateTimeFormat(undefined, mergedOptions).format(date);
}

export function formatDateTimeLikeSystem(isoString, dateOnly = false) {
    console.warn("Calling deprecated function: formatDateTimeLikeSystem");
    const options = {
        hour: dateOnly ? undefined : 'numeric',
        minute: dateOnly ? undefined : 'numeric',
        second: dateOnly ? undefined : 'numeric'
    };
    
    return formatDateTime(isoString, options);
}

export function formatDateOnly(isoString) {
    return formatDateTime(isoString, {
        hour: undefined,
        minute: undefined,
        second: undefined
    });
}

export function formatTimeOnly(isoString) {
    return formatDateTime(isoString, {
        year: undefined,
        month: undefined,
        day: undefined
    });
}

export function formatDateTimeWithoutSeconds(isoString) {
    return formatDateTime(isoString, {
        second: undefined
    });
}

export function dayNumberToDayName(dayNumber){
  const days = [
    "Pondělí",  "Úterý", "Středa", "Čtvrtek", "Pátek", "Sobota", "Neděle"
  ];
  return days[dayNumber] ?? "";
}

export function monthNumberToMonthName(monthNumber){
  const months = [
    "Leden", "Únor", "Březen", "Duben", "Květen", "Červen",
    "Červenec", "Srpen", "Září", "Říjen", "Listopad", "Prosinec"
  ];
  return months[monthNumber] ?? "";
}

export const formatUtcTime = (hour, minute) => {
  const date = new Date(Date.UTC(1970, 0, 1, hour, minute, 0, 0)); // force UTC
  return date.toISOString().split('T')[1]; // returns "09:34:00.000Z"
};

export const formatUtcTimeFromLocal = (hour, minute) => {
  // create LOCAL date at picked time
  const localDate = new Date();
  localDate.setHours(hour, minute, 0, 0);

  // extract UTC components
  const utcHour = localDate.getUTCHours();
  const utcMinute = localDate.getUTCMinutes();

  return formatUtcTime(utcHour, utcMinute);
};

export const formatUtcTimeToLocalHHmm = (utcTimeStr) => {
  if (!utcTimeStr) return "-";

  // utcTimeStr like "10:00:00.000Z"
  const [hh, mm] = utcTimeStr.split(":").map((x) => parseInt(x, 10));

  // anchor to a date, build a UTC Date, then read local hours/minutes
  const d = new Date(Date.UTC(2000, 0, 1, hh, mm || 0, 0, 0));

  const pad = (n) => String(n).padStart(2, "0");
  return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
};